<template>
  <div v-if="listaRetirada.length > 0">
    <div class="q-mt-xl">
      <div
        class="row justify-between text-h6 container-texto-input-search text-brand-5 text-weight-bold q-mt-lg q-mb-lg"
      >
        <span class="q-mb-md"
          >Histórico de Retiradas Item:
          {{ item?.nome != "" ? item?.nome : item?.id }}</span
        >
      </div>
      <q-linear-progress v-if="loading" indeterminate size="3px" />
      <q-table
        :class="{ 'my-sticky-dynamic': !mobile }"
        :rows="listaRetirada"
        :columns="columns"
        :hide-bottom="!listaRetirada.length == 0"
        :rows-per-page-options="[0]"
        no-data-label="Nenhum histórico do item encontrado."
        flat
        :grid="$q.screen.lt.sm"
        dense
      >
        <template v-slot:item="props">
          <div class="q-pa-xs row col-12">
            <q-card class="container-grid-table col-12">
              <div class="q-pa-sm">
                <div class="row col-12 items-center">
                  <div class="col">
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Unidade:</strong>
                      <span> {{ props.row.EntregaUnidadeNome }}</span>
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Cód C/C:</strong>
                      <span> {{ props.row.CentroCustoCodigo }}</span>
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Área:</strong>
                      <span> {{ props.row.CentroCustoNome }}</span>
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Num Requisição:</strong>
                      <span> {{ props.row.RequisicaoNumero }}</span>
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Finalização:</strong>
                      <span>
                        {{
                          props.row.FinalizacaoData?.split(" ")[0]
                            .split("-")
                            .reverse()
                            .join("/")
                        }}</span
                      >
                      <span class="q-ml-xs">
                        {{ props.row.FinalizacaoData?.split(" ")[1] }}</span
                      >
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Solicitante:</strong>
                      <span>
                        {{ props.row.SolicitanteNome }}-{{
                          props.row.SolicitanteSap
                        }}</span
                      >
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Código Produto:</strong>
                      <span> {{ props.row.ItemCodigo }}</span>
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Produto:</strong>
                      <span> {{ props.row.ItemNome }}</span>
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">EPI:</strong>
                      <span>
                        <q-icon
                          v-if="props.row.ItemEpi"
                          size="15px"
                          color="green"
                          name="check_circle" />
                        <q-icon v-else size="15px" color="red" name="cancel"
                      /></span>
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Quantidade:</strong>
                      <span>
                        {{
                          parseFloat(props.row.ItemQuantidade).toFixed(2)
                        }}</span
                      >
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Preço:</strong>
                      <span>
                        {{
                          props.row?.ItemPreco != null
                            ? `R$ ${props.row.ItemPreco}`
                            : "Sem preço"
                        }}</span
                      >
                    </div>
                    <div class="row col-12 items-center">
                      <strong class="q-mr-xs">Total:</strong>
                      <span>
                        {{
                          props.row?.TotalItemVoucher != null
                            ? `R$ ${props.row.TotalItemVoucher}`
                            : "Sem total"
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </q-card>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td>{{ props.row.EntregaUnidadeNome }}</q-td>
            <q-td>{{ props.row.CentroCustoCodigo }}</q-td>
            <q-td>{{ props.row.CentroCustoNome }}</q-td>
            <q-td>{{ props.row.RequisicaoNumero }}</q-td>
            <q-td>
              <span class="row">{{
                props.row.FinalizacaoData?.split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}</span>
              <span class="q-ml-sm">{{
                props.row.FinalizacaoData?.split(" ")[1]
              }}</span>
            </q-td>
            <q-td
              >{{ props.row.SolicitanteNome }}-{{
                props.row.SolicitanteSap
              }}</q-td
            >
            <q-td>{{ props.row.ItemCodigo }}</q-td>
            <q-td>{{ props.row.ItemNome }}</q-td>
            <q-td>
              <q-icon
                v-if="props.row.ItemEpi"
                size="20px"
                color="green"
                name="check_circle"
              />
              <q-icon v-else size="20px" color="red" name="cancel" />
            </q-td>
            <q-td>{{ parseFloat(props.row.ItemQuantidade).toFixed(2) }}</q-td>
            <q-td class="coluna-preco">{{
              props.row?.ItemPreco != null
                ? `R$ ${props.row.ItemPreco}`
                : "Sem preço"
            }}</q-td>
            <q-td class="coluna-preco">{{
              props.row?.TotalItemVoucher != null
                ? `R$ ${props.row.TotalItemVoucher}`
                : "Sem total"
            }}</q-td>
          </q-tr>
        </template>
      </q-table>
      <div class="row justify-center q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { useQuasar } from "quasar";
import { ref, watch, computed } from "vue";
import { useStore } from "vuex";

const columns = [
  {
    name: "unidade",
    label: "Unidade",
    align: "left",
  },
  {
    name: "codCC",
    label: "Cód C/C",
    align: "left",
  },
  {
    name: "area",
    label: "Área",
    align: "left",
  },
  {
    name: "numeroRequisicao",
    label: "Num Requisição",
    align: "left",
  },
  {
    name: "finalizacao",
    label: "Finalização",
    align: "left",
  },
  {
    name: "solicitante",
    label: "Solicitante",
    align: "left",
  },
  {
    name: "codigoProduto",
    label: "Cód Produto",
    align: "left",
  },
  {
    name: "produto",
    label: "Produto",
    align: "left",
  },
  {
    name: "epi",
    label: "EPI",
    align: "left",
  },
  {
    name: "qtd",
    label: "QTD",
    align: "left",
  },
  {
    name: "unitario",
    label: "Unitário",
    align: "left",
  },
  {
    name: "total",
    label: "Total",
    left: "left",
  },
];

export default {
  props: ["solicitanteId", "item", "atualizar", "resetar"],
  setup(props) {
    const store = useStore();
    const quasar = useQuasar();

    const listaRetirada = ref([]);
    const loading = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    let disable = ref(false);
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarHistoricoRetirada = async (page = 1, rowsNumber = 15) => {
      loading.value = true;
      disable.value = true;
      try {
        const response = await store.dispatch(
          "requisicao/listarHistoricoRetirada",
          {
            dataInicial: "01/01/2022",
            page: page,
            perPage: mobile.value ? 5 : rowsNumber,
            item: props.item?.id,
            solicitante: props.solicitanteId,
          }
        );
        listaRetirada.value = response.data.return.data;
        pagination.value.page = response.data.return.current_page;
        pagination.value.rowsPerPage = response.data.return.per_page;
        pagination.value.rowsNumber = response.data.return.total;
        if (listaRetirada.value.length == 0) {
          quasar.notify({
            message: "Nenhum histórico do item encontrado.",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    watch(
      () => props.atualizar,
      () => {
        listarHistoricoRetirada();
      }
    );

    watch(
      () => props.solicitanteId,
      () => {
        listaRetirada.value = [];
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarHistoricoRetirada(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }
    );

    return {
      columns,
      listaRetirada,
      listarHistoricoRetirada,
      loading,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      mobile,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
tbody tr td {
  white-space: pre-wrap;
}
tbody tr .coluna-selecionar {
  width: 40px !important;
  margin: 0px;
  padding: 3px 2px;
}
tbody tr td {
  white-space: pre-wrap;
}
tbody tr .coluna-preco {
  width: 120px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
@media (max-width: 600px) {
  .container-texto-input-search {
    font-size: 14px !important;
    width: 100%;
    margin-bottom: 20px;
  }
}
</style>
